let notificationsAllowed = true;
export function pushNotificationsAllowed(): boolean { return notificationsAllowed; }
export function withPushPresentation<T>(allowed: boolean, apply: () => T): T {
  const previous = notificationsAllowed;
  notificationsAllowed = allowed;
  try { return apply(); } finally { notificationsAllowed = previous; }
}
